import React, { Component } from 'react';
import NotesCardFooter from '../../../../Components-2025/Notes/CardFooter';
import CustomCard from '../../../../Components-2025/Notes/CustomCard';
import CustomCardHeader from '../../../../Components-2025/QuestionBank/CustomCardHeader';
import ReportCard from '../../../../Components-2025/QuestionBank/ReportCard';
import notesIcon from '../../../../assets/img/notes/notes_icon4.svg';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import CardBlockLoaderWrapper from '../../../../components/CardBlockLoaderWrapper';
import FlashCard from '../../../../components/FlashCard';
import config from '../../../config/AppRoutes';
import { descriptionKey, notesIdKey, notesNameKey, notesReadingIdKey } from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import { renderHTMLContent } from '../../../../common/function';
export default class ViewNotes extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      notesList: [],
      currentNoteObj: {},
      isFlashCardHidden: true,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    const { level, readingId, chapterId } = this.props.params;
    const result = await apiServiceProvider['fetchNotes']({ level, readingId, chapterId });
    if (result.success) {
      const { questions } = result;
      this.setState({ isLoading: false, notesList: questions });
      await this.onSetCurrentNote(questions);
    }
    this.setState({ isLoading: false });
  }

  onSetCurrentNote = async (notesData) => {
    const { notesId, readingId } = this.props.params;
    if (notesId !== ':notesId') {
      const index = notesData.findIndex((item) => item[notesIdKey] === parseInt(notesId, 10));
      this.setState({ currentIndex: index });
    } else {
      const index = notesData.findIndex(
        (item) => item[notesReadingIdKey] === parseInt(readingId, 10),
      );
      this.setState({ currentIndex: index });
    }
    this.setState({ isLoading: false });
  };
  resetStates = () => {
    this.setState({
      showAnswer: false,
      showReportSection: false,
      selectedChoice: '',
      stopTimer: false,
    });
  };
  replaceRoute = (index) => {
    const { notesList } = this.state;
    const { readingId, chapterId, notesId, level } = this.props.params;
    const { router } = this.context;

    const id = notesList[index] ? notesList[index].id : notesId;

    router.push({
      pathname: config.FRM_V2_NOTES_VIEW.replace(':level', level)
        .replace(':readingId', readingId)
        .replace(':chapterId', chapterId)
        .replace(':notesId', id),
    });
    this.setState({ currentIndex: index, currentNoteObj: notesList[index] });
  };

  getPreviousQuestion = () => {
    const { currentIndex } = this.state;
    if (parseInt(currentIndex, 10) > 0) {
      this.replaceRoute(currentIndex - 1);
      this.resetStates();
    }
  };
  getNextQuestion = () => {
    const { notesList, currentIndex } = this.state;
    const index = parseInt(currentIndex, 10) + 1;
    if (index < notesList.length) {
      this.replaceRoute(index);
      this.resetStates();
    }
  };
  onSaveItemChange = (status) => {
    this.setState({ isFlashCardHidden: status });
  };

  toggleReportSection = () =>
    this.setState((prevState) => ({ showReportSection: !prevState.showReportSection }));

  hideReportSection = () => {
    this.setState({ showReportSection: false });
  };
  render() {
    const { isLoading, notesList, currentIndex, isFlashCardHidden, showReportSection } = this.state;
    const { level, chapterId } = this.props.params;
    const { router } = this.context;
    return (
      <div className='row col-sm-12 d-block'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={messages.NOTES} className='note-section notes_inner_title_wrap '>
          <CustomButton
            onClick={() =>
              router.push({
                pathname: config.FRM_V2_NOTES_READING_LIST.replace(':level', level).replace(
                  ':chapterId',
                  chapterId,
                ),
                state: notesList.length && { notesList },
              })
            }
          >
            {messages.CHANGE_READING}
          </CustomButton>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}=========================================== */}
        <div>
          <CustomCard style={isLoading && { height: '800px' }}>
            <CardBlockLoaderWrapper isLoading={isLoading} />
            {currentIndex >= 0 ? (
              <div>
                <CustomCardHeader
                  headingText={
                    notesList.length &&
                    `${notesList[currentIndex][notesNameKey]} (N. ${notesList[currentIndex][notesIdKey]
                    })`
                  }
                  showPreviousButton={true}
                  showNextButton={true}
                  headerImage={notesIcon}
                  arrayLength={notesList.length}
                  disabledPreviousButton={currentIndex < 1}
                  disabledNextButton={!(currentIndex < notesList.length - 1)}
                  getPreviousQuestion={this.getPreviousQuestion}
                  getNextQuestion={this.getNextQuestion}
                />
                {renderHTMLContent(
                  notesList.length && notesList[currentIndex][descriptionKey],
                  "div",
                  "mt-3 note_text_wrap"
                )}
                <NotesCardFooter
                  isLoading={isLoading}
                  savePayLoad={{
                    question_id: notesList.length && notesList[currentIndex][notesIdKey],
                    level,
                  }}
                  level={level}
                  favItemId={notesList.length && notesList[currentIndex][notesIdKey]}
                  setChildRef={this.childRef}
                  apiServiceProvider={apiServiceProvider}
                  onSaveItemChange={this.onSaveItemChange}
                  toggleReportSection={this.toggleReportSection}
                />
              </div>
            ) : (
              <h1 className='text-center pt-3 pb-3'>{!isLoading && messages.NO_DATA_FOUND}</h1>
            )}
          </CustomCard>
        </div>
        <div className='col-sm-12 note-section p-0'>
          {currentIndex >= 0 && (
            <div>
              <FlashCard
                item={{ id: notesList.length && notesList[currentIndex][notesIdKey] }}
                type='notes'
                isFlashCardHidden={isFlashCardHidden}
                ref={this.setChildRef}
                exam='frm'
                level={level}
              />
              {showReportSection && (
                <ReportCard
                  hideReportSection={this.hideReportSection}
                  apiServiceProvider={apiServiceProvider}
                  itemId={notesList.length && notesList[currentIndex][notesIdKey]}
                  keyId='question_id'
                />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/View/ViewNotes.jsx